import {
  TOOTH_GUM_TYPE,
  TOOTH_GUM_TYPE_KEY,
  TOOTH_STAGE_NUMBER_KEY,
} from "../constant/toothConstant";
import {
  getStageDOFromFolderPath,
  getStageFileDOFromFilePath,
} from "../matcher-tools/stageMatcher";

export const getStageFolderListFromZip = async (zip) => {
  const stageFolderList = [];
  const stageFileMap = {};
  const stageDOList = [];

  const pathList = Object.keys(zip.files);

  for (const path of pathList) {
    const stageFolderDO = await getStageDOFromFolderPath(path);
    if (stageFolderDO) {
      stageFolderList.push(stageFolderDO);
    }
  }

  for (const path of pathList) {
    const stageFileDO = await getStageFileDOFromFilePath(path);
    if (stageFileDO) {
      const { stageNumber, toothGumType } = stageFileDO;
      const stageKey = `${TOOTH_STAGE_NUMBER_KEY}:${stageNumber}.${TOOTH_GUM_TYPE_KEY}:${toothGumType}`;
      stageFileMap[stageKey] = stageFileDO;
    }
  }

  const sortedStageFolderList = stageFolderList.sort((a, b) => {
    return a.stageNumber - b.stageNumber;
  });

  let preLowerStageNumber = undefined;
  let preUpperStageNumber = undefined;

  for (const stageFolderDO of sortedStageFolderList) {
    const { stageNumber } = stageFolderDO;

    const upperStageKey = `${TOOTH_STAGE_NUMBER_KEY}:${stageNumber}.${TOOTH_GUM_TYPE_KEY}:${TOOTH_GUM_TYPE.UPPER}`;
    const lowerStageKey = `${TOOTH_STAGE_NUMBER_KEY}:${stageNumber}.${TOOTH_GUM_TYPE_KEY}:${TOOTH_GUM_TYPE.LOWER}`;

    const upperStageFileDO = stageFileMap[upperStageKey];
    const lowerStageFileDO = stageFileMap[lowerStageKey];

    preUpperStageNumber = preUpperStageNumber || stageNumber;
    preLowerStageNumber = preLowerStageNumber || stageNumber;

    if (upperStageFileDO) {
      preUpperStageNumber = stageNumber;
    }

    if (lowerStageFileDO) {
      preLowerStageNumber = stageNumber;
    }

    const upperStageNumber = !upperStageFileDO
      ? preUpperStageNumber
      : stageNumber;
    const lowerStageNumber = !lowerStageFileDO
      ? preLowerStageNumber
      : stageNumber;

    const upperVisible = !!upperStageFileDO;
    const lowerVisible = !!lowerStageFileDO;

    const stageDO = {
      stageNumber,
      lowerStageNumber,
      upperStageNumber,
      lowerVisible,
      upperVisible,
    };

    stageDOList.push(stageDO);
  }

  return stageDOList;
};
